<div class="district-dashboard">
  <wf-page-tour [steps]="tourSteps()"></wf-page-tour>
  <!-- Slot for report filter -->
  <!-- To use: <div report-filter>{{ filter content }}</div> -->
  <ng-content select="[report-filter]"></ng-content>

  <div class="dashboard-toolbar">
    <button id="printButton" class="btn print-summary-button" (click)="onPrintClicked()"><fa-icon [icon]="printIcon"></fa-icon> Print</button>
  </div>

  <div class="dashboard-header-bar">{{ reportTitle() }}</div>

  <div *ngIf="loadError()" class="alert message alert-danger">{{ loadError() }}</div>

  <!-- Report body -->
  <ng-content></ng-content>
</div>
